<template>
    <canvas ref="canvasRef" />
</template>
<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarController, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarController, BarElement, CategoryScale, LinearScale)

export default {
    name: 'chart-bar',
    props: {
        chartData: {
            type: Object,
            required: true
          },
        chartOptions: {
          type: Object,
          default: () => {}
        }
    },
    data() {
    	return {
    		 chartInstance: null
    	}
    },
	watch: {
	  chartData(newData) {
	    this.chartInstance.data = newData
	    this.chartInstance.update()
	  },
	  chartOptions(newOptions) {
	    this.chartInstance.options = newOptions
	    this.chartInstance.update()
	  }
	},
    mounted() {
         this.chartInstance = new ChartJS(this.$refs.canvasRef, {
            type: 'bar',
            data: this.chartData,
            options: this.chartOptions
          })
    },
    beforeUnmount() {
        this.chartInstance?.destroy()
    }
}
</script>